import React from 'react';

const Introduction = () => {
  return (
    <section className="min-h-screen flex items-center py-20 px-4 sm:px-6 lg:px-8 bg-white">
      <div className="max-w-7xl mx-auto">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
          <div>
            <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-8">
              Built on Expertise,<br />
              Driven by Safety
            </h2>
            <p className="text-xl text-gray-600 leading-relaxed mb-6">
              Founded by industry experts, our team provides end-to-end safety lifecycle management for hazardous facilities.
            </p>
            <p className="text-lg text-gray-600 leading-relaxed">
              With decades of combined experience in functional safety, we understand the critical nature of your operations and the importance of maintaining the highest safety standards while ensuring operational efficiency.
            </p>
          </div>
          <div className="relative">
            <img
              src="/assets/asset-15.jpg"
              alt="Professional team in technical workspace"
              className="rounded-lg shadow-2xl"
            />
            <div className="absolute -bottom-6 -right-6 w-72 h-72 bg-blue-100 rounded-lg -z-10"></div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Introduction;
